import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
 Button, Input, Select, Table,
} from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import moment from 'moment';
import getColumns from './leading-count/ExceptionalRouteLeadingCountTypesColumns';
import { putRouteEditRequestActionCreator } from '../redux/actions/EditRouteActions';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getLeftPostalOperators } from '../../../../common/user/redux/selectors/UserDataSelectors';
import ExceptionalRouteLeadingCountTypeEntryDialog from './leading-count/ExceptionalRouteLeadingCountTypeEntryDialog';
import ExceptionalRouteLeadingCountTypeDeleteDialog from './leading-count/ExceptionalRouteLeadingCountTypeDeleteDialog';
import TransferOperatorsContainer from '../../transfer-operators/TransferOperatorsContainer';
import filterIMPCCodesIfExistsInPostalOperators
  from '../../../../common/selection-criteria/operator-impc/mapper-filter/filterImpc';
import { retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator } from '../../../../common/selection-criteria/operator-impc/redux/actions/OperatorImpcActions';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

const options = [
  { label: 'Priority', value: 'PRIORITY' },
  { label: 'Non Priority', value: 'NONPRIORITY' },
  { label: 'Both', value: 'BOTH' },
];

class EditRouteContainer extends Component {
  constructor(props) {
    super(props);
    const palletBoxData = props.appContext.appContext === 'pallet' ? {
      exceptionalLeadingCounts: this.props.location.data.original.routeLeadingCountDtos
        ? this.props.location.data.original.routeLeadingCountDtos : null,
      transferLocations: this.props.location.data.original.transferImpcs
        ? this.props.location.data.original.transferImpcs : null,
      exceptionalLeadingCountDialogOpen: false,
      selectedExceptionalLeadingCountId: null,
      selectedExceptionalLeadingCountStartDate: null,
      selectedExceptionalLeadingCountEndDate: null,
      deleteExceptionalLeadingCountDialogOpen: false,
    } : {};

    this.state = {
      priority: this.props.location.data.original.priority,
      comments: '',
      startDate: this.props.location.data.original.startDate,
      endDate: this.props.location.data.original.endDate,
      validEndDate: true,
      ...palletBoxData,
    };

    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.confirm = this.confirm.bind(this);
  }

  componentDidMount() {
    if (this.props.appContext.appContext === 'pallet') {
      this.props.retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator();
    }
  }

  onTransferLocationChecked = (checkedTransferLocations) => {
    this.setState({
      transferLocations: filterIMPCCodesIfExistsInPostalOperators(
        checkedTransferLocations,
        this.props.transferOperatorNodes,
      ),
    });
  }

  onChangePriority = (selected) => {
    this.setState({ priority: selected.value });
  };

  onChangeComments = (e) => {
    this.setState({
      comments: e.target.value,
    });
  }

  onChangeEndDate(date) {
    this.setState((prevState) => ({
      endDate: date,
      validEndDate: this.validateExceptionalLeadingCountDates(prevState),
    }));
  }

  onInvalidEndDate = (message) => {
    this.setState((prevState) => ({
      validEndDate: message === '' && this.validateExceptionalLeadingCountDates(prevState),
    }));
  }

  onExceptionalLeadingCountDialogApply = (id, startDate, endDate) => {
    this.setState((prevState) => {
      let { exceptionalLeadingCounts } = prevState;
      if (id === null) {
        exceptionalLeadingCounts = exceptionalLeadingCounts.concat([{
          id: null,
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          type: 'MAX_EDI_RFID',
          isEditable: true,
        }]);
      } else {
        exceptionalLeadingCounts = exceptionalLeadingCounts.map((leadingCount) => {
          if (leadingCount.id === id) {
            return {
              ...leadingCount,
              startDate: moment(startDate).format('YYYY-MM-DD'),
              endDate: endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
              isEditable: true,
            };
          }
          return leadingCount;
        });
      }
      return {
        exceptionalLeadingCountDialogOpen: false,
        exceptionalLeadingCounts,
      };
    });
  }

  openExceptionalLeadingCountDialog = (id, startDate, endDate) => {
    this.setState({
      selectedExceptionalLeadingCountId: id,
      selectedExceptionalLeadingCountStartDate: startDate,
      selectedExceptionalLeadingCountEndDate: endDate,
      exceptionalLeadingCountDialogOpen: true,
    });
  }

  closeExceptionalLeadingCountDialog = () => {
    this.setState({
      exceptionalLeadingCountDialogOpen: false,
    });
  }

  openDeleteExceptionalLeadingCountDialog = (id) => {
    this.setState({
      selectedExceptionalLeadingCountId: id,
      deleteExceptionalLeadingCountDialogOpen: true,
    });
  }

  closeDeleteExceptionalLeadingCountDialog = () => {
    this.setState({
      deleteExceptionalLeadingCountDialogOpen: false,
    });
  }

  onDeleteExceptionalLeadingCountConfirm = (id) => {
    this.setState((prevState) => ({
      selectedExceptionalLeadingCountId: null,
      deleteExceptionalLeadingCountDialogOpen: false,
      exceptionalLeadingCounts: prevState.exceptionalLeadingCounts.filter((leadingCount) => leadingCount.id !== id),
    }));
  }

  getExceptionalLeadingCountColumns = () => {
    const columns = getColumns(this.state.data);
    const now = moment().startOf('day');
    columns[0].columns.push({
      Header: 'Actions',
      accessor: 'id',
      sortable: false,
      width: 170,
      Cell: (cell) => {
        const startDate = moment(cell.original.startDate);
        return (
          <>
            {(cell.original.id === null || startDate === now || startDate.isAfter(now)) && (
              <Button
                onClick={() => this.openExceptionalLeadingCountDialog(cell.original.id, cell.original.startDate, cell.original.endDate)}
              >
                Edit
              </Button>
            )}
            {(cell.original.id === null || startDate.isAfter(now)) && (
              <Button onClick={() => this.openDeleteExceptionalLeadingCountDialog(cell.original.id)}>Delete</Button>
            )}
          </>
        );
      },
    });
    return columns;
  };

  validateExceptionalLeadingCountDates = (prevState) => {
    if (prevState.exceptionalLeadingCounts === undefined || prevState.exceptionalLeadingCounts === null
      || prevState.exceptionalLeadingCounts.length === 0) {
      return true;
    }

    const routeStartDate = moment(this.state.startDate).startOf('day');
    const routeEndDate = this.state.endDate === null ? moment('2999-12-31').endOf('day')
      : moment(this.state.endDate).endOf('day');

    return this.state.exceptionalLeadingCounts.filter((leadingCount) => {
      if (leadingCount.endDate === null) {
        return null;
      }
      const leadingCountStartDate = moment(leadingCount.startDate).startOf('day');
      const leadingCountEndDate = moment(leadingCount.endDate);

      if (leadingCountStartDate.isBetween(routeStartDate, routeEndDate) && leadingCountEndDate.isBetween(routeStartDate, routeEndDate)) {
        return null;
      }
      return leadingCount;
    }).length === 0;
  }

  isConfirmEnabled = () => this.state.validEndDate

  confirm() {
    this.props.putRouteEditRequestActionCreator(
      this.props.appContext,
      this.props.location.data.original.id,
      this.state.comments,
      this.state.endDate,
      this.state.priority,
      this.state.startDate,
      this.state.exceptionalLeadingCounts,
      this.state.transferLocations,
    );
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="general-content-container">
        <h1 className="title-div">EDIT ROUTE</h1>
        <table className="edit-route-detail-form">
          <tbody>
            <tr>
              <td className="edit-route-input">Outbound Operator</td>
              <td className="edit-route-input">
                {this.props.location.data.original.outboundOperator}
              </td>
              <td className="edit-route-input">Inbound Operator</td>
              <td className="edit-route-input">
                {this.props.location.data.original.inboundOperator}
              </td>
            </tr>
            <tr>
              <td className="edit-route-input">Outbound IMPC</td>
              <td className="edit-route-input">
                {this.props.location.data.original.outboundImpc}
              </td>
              <td className="edit-route-input">Inbound IMPC</td>
              <td className="edit-route-input">
                {this.props.location.data.original.inboundImpc}
              </td>
            </tr>
            {this.props.appContext.appContext === 'pallet' && (
              <tr>
                <td className="edit-route-input">Transfer Locations</td>
                <td className="edit-route-input" colSpan={3}>
                  <div className="transfer-operator-container">
                    <TransferOperatorsContainer
                      nodes={this.props.transferOperatorNodes}
                      checked={this.state.transferLocations}
                      onCheck={this.onTransferLocationChecked}
                    />
                  </div>
                </td>
              </tr>
            )}
            <tr>
              <td className="edit-route-input">Start Date</td>
              <td className="edit-route-input">
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <Grid container>
                    <KeyboardDatePicker
                      disableToolbar
                      autoOk
                      format="dd-MM-yyyy"
                      margin="normal"
                      id="route-start-date"
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      value={this.state.startDate}
                      disabled
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </td>
              <td className="edit-route-input">End Date</td>
              <td className="edit-route-input">
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <Grid container>
                    <KeyboardDatePicker
                      disableToolbar
                      autoOk
                      format="dd-MM-yyyy"
                      margin="normal"
                      id="route-end-date"
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      value={this.state.endDate}
                      onChange={this.onChangeEndDate}
                      minDate={this.state.startDate}
                      onError={this.onInvalidEndDate}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </td>
            </tr>
            <tr>
              <td className="edit-route-input">Priority Type</td>
              <td className="edit-route-input">
                <Select
                  value={this.state.priority}
                  placeholder={this.state.priority}
                  options={options}
                  onChange={this.onChangePriority}
                />
              </td>
            </tr>
            <tr>
              <td className="edit-route-input">Comment</td>
              <td className="edit-route-input">
                <Input
                  value={this.state.comments}
                  onChange={this.onChangeComments}
                  maxLength="40"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="operator-info-div">
          {this.props.appContext.appContext === 'pallet' && (
            <>
              <hr />
              <h2 className="title-div" style={{ marginLeft: '-2px' }}>Exceptional Route Leading Count</h2>
              <Button
                onClick={() => this.openExceptionalLeadingCountDialog(
                  null,
                  moment().add(1, 'day').startOf('day').format('YYYY-MM-DD'),
                  this.state.endDate,
                )}
                style={{ marginBottom: '5px' }}
              >
                Add New
              </Button>
              <Table
                noDataText="No exceptional leading count is defined."
                columns={this.getExceptionalLeadingCountColumns()}
                data={this.state.exceptionalLeadingCounts}
                pageSize={this.state.exceptionalLeadingCounts.length}
                showPagination={false}
              />
              {this.state.exceptionalLeadingCountDialogOpen && (
                <ExceptionalRouteLeadingCountTypeEntryDialog
                  id={this.state.selectedExceptionalLeadingCountId}
                  startDate={this.state.selectedExceptionalLeadingCountStartDate}
                  endDate={this.state.selectedExceptionalLeadingCountEndDate}
                  routeStartDate={this.state.startDate}
                  routeEndDate={this.state.endDate}
                  leadingCountList={this.state.exceptionalLeadingCounts}
                  onApply={this.onExceptionalLeadingCountDialogApply}
                  closeDialog={this.closeExceptionalLeadingCountDialog}
                  openDialog={this.openExceptionalLeadingCountDialog}
                />
              )}
              {this.state.deleteExceptionalLeadingCountDialogOpen && (
                <ExceptionalRouteLeadingCountTypeDeleteDialog
                  id={this.state.selectedExceptionalLeadingCountId}
                  onConfirm={() => this.onDeleteExceptionalLeadingCountConfirm(this.state.selectedExceptionalLeadingCountId)}
                  closeDialog={this.closeDeleteExceptionalLeadingCountDialog}
                  openDialog={() => this.openDeleteExceptionalLeadingCountDialog(this.state.selectedExceptionalLeadingCountId)}
                />
              )}
            </>
          )}
          <table>
            <tbody>
              <tr>
                <td className="edit-route-input" style={{ paddingBottom: '20px' }}>
                  <Button onClick={this.props.history.goBack}>Cancel</Button>
                </td>
                <td className="edit-route-input" style={{ paddingBottom: '20px' }}>
                  <Button
                    disabled={!this.isConfirmEnabled()}
                    className={`primary-button-${!this.isConfirmEnabled()}`}
                    onClick={this.confirm}
                  >
                    Confirm
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
    transferOperatorNodes: getLeftPostalOperators(state),
  };
}

EditRouteContainer.propTypes = {
  putRouteEditRequestActionCreator: PropTypes.func,
  retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator: PropTypes.func,
  location: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.string),
  transferOperatorNodes: PropTypes.arrayOf(PropTypes.object),
  history: PropTypes.objectOf(PropTypes.shape),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  putRouteEditRequestActionCreator,
  retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditRouteContainer);
